// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hkN-9","title":"styles_title__OpH2N","inputs_wrapper":"styles_inputs_wrapper__+6Nyf","input_wrapper":"styles_input_wrapper__ztAed"};